import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import ErrorBoundary from './ErrorBoundary'
import './src/styles/globals.css'
import { injectSpeedInsights } from '@vercel/speed-insights';

// Inject Vercel Speed Insights
injectSpeedInsights();

// Debug logging
console.log('main.tsx: Starting application...');
console.log('Environment:', {
  location: window.location.href,
  userAgent: navigator.userAgent,
  reactVersion: React.version
});

// Function to hide loading screen
function hideLoadingScreen() {
  const loadingElement = document.getElementById('loading');
  if (loadingElement) {
    console.log('main.tsx: Hiding loading screen');
    loadingElement.style.opacity = '0';
    loadingElement.style.transition = 'opacity 0.5s ease-out';
    setTimeout(() => {
      loadingElement.style.display = 'none';
    }, 500);
  }
}

// Ensure DOM is ready
if (document.getElementById('root')) {
  console.log('main.tsx: Root element found, creating React app...');
  
  try {
    ReactDOM.createRoot(document.getElementById('root')!).render(
      <React.StrictMode>
        <ErrorBoundary>
          <App />
        </ErrorBoundary>
      </React.StrictMode>,
    );
    
    console.log('main.tsx: React app rendered successfully');
    
    // Hide loading screen after a short delay to ensure React has painted
    setTimeout(hideLoadingScreen, 200);
  } catch (error) {
    console.error('main.tsx: Error rendering React app:', error);
    hideLoadingScreen();
    
    // Show error in DOM
    const rootElement = document.getElementById('root');
    if (rootElement) {
      rootElement.innerHTML = `
        <div style="padding:16px;font-family:monospace;background:var(--odpm-panel);color:var(--odpm-text);margin:20px;border:1px solid var(--odpm-border);border-radius:8px;">
          <h2 style="margin:0 0 8px;color:var(--odpm-danger);">🚨 Application Error</h2>
          <p style="margin:0 0 6px;"><strong style="color:var(--odpm-text-strong);">Error:</strong> ${error instanceof Error ? error.message : String(error)}</p>
          <p style="margin:0 0 10px;">Check browser console for more details.</p>
          <details style="margin-top:12px;">
            <summary style="cursor:pointer;color:var(--odpm-primary);">Technical Details</summary>
            <pre style="background:#232830;color:var(--odpm-text-strong);padding:10px;margin-top:10px;overflow:auto;border:1px solid var(--odpm-border);border-radius:6px;">${error instanceof Error ? error.stack : String(error)}</pre>
          </details>
        </div>
      `;
    }
  }
} else {
  console.error('main.tsx: Root element not found!');
  hideLoadingScreen();
}